import { useEffect, useState } from 'react';

import {
  forgetToothSliceCard,
  getToothSliceScrollRoot,
  getToothSliceStickyHeaderHeight,
  setToothSliceCardVisible,
  subscribeToToothSliceScrollRoot,
} from '../lib';

import { useIsInViewport } from './useIsInViewport';

export const useToothSliceCardVisibility = (toothID: string) => {
  const [scrollRoot, setScrollRoot] = useState(getToothSliceScrollRoot);
  const [stickyHeaderHeightPx, setStickyHeaderHeightPx] = useState(
    getToothSliceStickyHeaderHeight,
  );

  useEffect(() => {
    const sync = () => {
      setScrollRoot(getToothSliceScrollRoot());
      setStickyHeaderHeightPx(getToothSliceStickyHeaderHeight());
    };

    const unsubscribe = subscribeToToothSliceScrollRoot(sync);

    sync();

    return () => {
      unsubscribe();
    };
  }, []);

  return useIsInViewport({
    root: scrollRoot,
    rootMarginTopPx: scrollRoot ? -stickyHeaderHeightPx : undefined,
    onChange: (isVisible) => {
      if (isVisible) {
        setToothSliceCardVisible(toothID);

        return;
      }

      forgetToothSliceCard(toothID);
    },
  });
};
